import type { Frente } from './schemas';

/**
 * Categoria da checagem que gerou o sinal. Os 5 nomes e o agrupamento vêm dos
 * grupos do accordion de camadas do mapa do CAR (`routes/imoveis.js`) — mexeu
 * num, alinhe o outro, senão o mapa e o CRM passam a nomear a mesma coisa de
 * jeitos diferentes.
 */
export const CATEGORIAS = [
  'Alertas e Desmatamento',
  'APP e Reserva Legal',
  'Áreas Protegidas',
  'Fundiário e Cadastro',
  'Embargos e Autuações',
] as const;
export type Categoria = (typeof CATEGORIAS)[number];

/** `crm_oportunidade.verificacao` → categoria. Valores conferidos em prod. */
const POR_VERIFICACAO: Record<string, Categoria> = {
  prodes: 'Alertas e Desmatamento',
  deter: 'Alertas e Desmatamento',
  mapbiomas: 'Alertas e Desmatamento',
  cnfp: 'Áreas Protegidas',
  uc: 'Áreas Protegidas',
  ti: 'Áreas Protegidas',
  quilombola: 'Áreas Protegidas',
  sigef: 'Fundiário e Cadastro',
  sicar: 'Fundiário e Cadastro',
  ccir_externo: 'Fundiário e Cadastro',
  glebas: 'Fundiário e Cadastro',
  assentamento: 'Fundiário e Cadastro',
  embargo_estadual: 'Embargos e Autuações',
  ibama_embargo_geo: 'Embargos e Autuações',
  ibama_autos: 'Embargos e Autuações',
  icmbio_autos: 'Embargos e Autuações',
  icmbio_embargo: 'Embargos e Autuações',
};

/**
 * `sobreposicao` e `Triagem manual` não têm categoria definida (pendência do
 * Weni, 2026-07-15) — sem chute: quem não mapeia não ganha etiqueta.
 */
export function categoriaDaVerificacao(verificacao: string | null | undefined): Categoria | null {
  if (!verificacao) return null;
  return POR_VERIFICACAO[verificacao.trim().toLowerCase()] ?? null;
}

/** Etiqueta de categoria: fundo tingido. Tokens em ui/tokens.css (light+dark). */
export const CATEGORIA_CLASS: Record<Categoria, string> = {
  'Alertas e Desmatamento': 'bg-[var(--cat-alertas-bg)] text-[var(--cat-alertas-fg)]',
  'APP e Reserva Legal': 'bg-[var(--cat-app-bg)] text-[var(--cat-app-fg)]',
  'Áreas Protegidas': 'bg-[var(--cat-protegidas-bg)] text-[var(--cat-protegidas-fg)]',
  'Fundiário e Cadastro': 'bg-[var(--cat-fundiario-bg)] text-[var(--cat-fundiario-fg)]',
  'Embargos e Autuações': 'bg-[var(--cat-embargos-bg)] text-[var(--cat-embargos-fg)]',
};

/** Etiqueta de triagem = esteira (`frente`). Fundo neutro + ponto da cor da frente. */
export const TRIAGEM_LABEL: Record<Frente, string> = {
  ambiental: 'Triagem Ambiental',
  fundiario: 'Triagem Fundiária',
  credito: 'Triagem de Crédito',
  juridico: 'Triagem Jurídica',
};

export const TRIAGEM_DOT: Record<Frente, string> = {
  ambiental: 'bg-[var(--frente-ambiental)]',
  fundiario: 'bg-[var(--frente-fundiario)]',
  credito: 'bg-[var(--frente-credito)]',
  juridico: 'bg-[var(--frente-juridico)]',
};
